import {useConfirm} from "material-ui-confirm";
import {DependencyList, useCallback} from "react";
import {message} from "./ActionUtil";
import {useMessage} from "./Message";

export function useDeleteAction<P>({description, action, successMessage, failureMessage}: {
    description: string,
    action: (param: P) => Promise<void>,
    successMessage: string | ((param: P) => string),
    failureMessage: string | ((param: P) => string),
}, depList: DependencyList) {
    const confirm = useConfirm();
    const msg = useMessage();
    
    /* eslint-disable react-hooks/exhaustive-deps */
    return useCallback(
        async (param: P) => {
            const {confirmed} = await confirm({
                title: 'Confirm Delete',
                description,
                confirmationText: 'Delete',
                confirmationButtonProps: {
                    color: 'error',
                    variant: 'contained',
                },
            });
            if (confirmed) {
                await msg.exec(
                    () => action(param),
                    message(successMessage, param),
                    message(failureMessage, param),
                );
            }
        },
        [confirm, msg, action, ...depList],
    );
    /* eslint-enable react-hooks/exhaustive-deps */
}
